export default __webpack_public_path__ + "static/media/maxim-logo.0b62969d.svg";